import API from 'utils/api';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';

export const baseURI = '/recaudacion/convenios/';

/**
 * GET Convenios
 * @returns {Promise<Array<object>>}
 */
export const getConvenios = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Convenio
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConvenio = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Convenio
 * @param {*} params
 * @returns {Promise<Array<object>>}
 */
export const postConvenio = async (params) => {
  try {
    const response = await API.post(`${baseURI}`, params);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Convenio
 * @param {*} params
 * @returns {Promise<Array<object>>}
 */
export const pagarConvenio = async (values) => {
  try {
    const response = await API.post(`${baseURI}pagar-convenio/`, values);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Cargos Convenidos
 * @param {object} params
 * @returns {Promise<Array<object>>}
 */
export const postCargosConvenidos = async (values) => {
  try {
    const response = await API.post('recaudacion/generar-cargos-convenidos', values, { accionInf: 'CARGOS_CONVENIOS' });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Convenios
 * @returns {Promise<Array<object>>}
 */
export const getTiposConvenios = async (params = null) => {
  try {
    const response = await API.get(`${baseURI}/tipos-de-convenio`, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Parcialidades
 * @returns {Promise<Array<object>>}
 */
export const generarParcialidades = async (values) => {
  try {
    const response = await API.post('recaudacion/parcialidad-de-convenio/generar-parcialidades/', (values));
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Parcialidades
 * @returns {Promise<Array<object>>}
 */
export const getParcialidades = async (params = null) => {
  try {
    const response = await API.get('recaudacion/parcialidades/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Cancelar Convenio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<boolean>}
 */
export const postCancelarConvenio = async (id, values) => {
  try {
    await API.post(`${baseURI}${id}/cancelar/`, values);
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * POST Cancelar Parcialidades
 * @param {object} values
 * @returns {Promise<boolean>}
 */
export const postCancelarParcialidades = async (values) => {
  try {
    await API.post('recaudacion/parcialidades/cancelar-parcialidades', values);
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};

export const postUploadFile = async (id, file) => {
  try {
    const files = ['file'];
    const headers = { 'Content-Type': 'multipart/form-data' };
    const formattedValues = getFormattedValues({ file }, {
      formData: true,
      files,
      clean: false,
    });

    const response = await API.post(`${baseURI}${id}/upload-zip/`, formattedValues, { headers });
    return response.data;
  } catch (error) {
    onError(error);
  }
  return false;
};
